<template>
  <div>
    <Page :title="pageTitle">
      <template v-slot:default>
        <div class="my-2">
          <div>
            <h3 class="text-base leading-6 font-medium text-gray-900 my-2">
              Select Date
            </h3>
            <DateRangePicker
              v-model="currentConfig"
              opens="right"
              :ranges="ranges"
              :minDate="minDate"
              @update="dateSelected"
            />
            <div v-if="isLoading">
              <Spinner />
            </div>
            <h3 class="text-lg leading-6 font-medium text-gray-900 mt-4">
              {{ dateDiff }}
            </h3>
            <h3 class="text-lg leading-6 font-medium text-gray-900 mt-5">
              Charges
            </h3>
            <div class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
              <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt
                      class="text-sm leading-5 font-medium text-gray-500 flex"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6 mr-2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
                        />
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                      Automated messages charges
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ automatedCharges }}
                    </dd>
                  </dl>
                </div>
              </div>

              <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt
                      class="text-sm leading-5 font-medium text-gray-500 flex"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6 mr-2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                        />
                      </svg>
                      Marketing messages charges
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ marketingCharges }}
                    </dd>
                  </dl>
                </div>
              </div>
              <div
                class="bg-white overflow-hidden shadow rounded-lg"
                v-if="
                  store.id === '6928339433262eb11da84eb8' ||
                  store.id === '6626ade478daa8c9d6df8e5f'
                "
              >
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt
                      class="text-sm leading-5 font-medium text-gray-500 flex"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6 mr-2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                        />
                      </svg>
                      Team Inbox messages charges
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ teamInboxCharges }}
                    </dd>
                  </dl>
                </div>
              </div>

              <div class="bg-white shadow rounded-lg relative">
                <div class="px-4 py-5 sm:p-6">
                  <dl>
                    <dt
                      class="text-sm leading-5 font-medium text-gray-500 flex items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6 mr-2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
                        />
                      </svg>
                      Usage Charge Units
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-500 hover:text-gray-700 cursor-pointer ml-2 usage-charge-info-icon"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        @click.stop="showUsageChargeInfo = !showUsageChargeInfo"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <div
                        v-if="showUsageChargeInfo"
                        class="absolute z-10 px-4 py-3 text-sm bg-gray-800 text-white rounded-lg shadow-lg max-w-xs usage-charge-info-tooltip"
                        style="top: 60px; left: 16px; white-space: normal"
                        @click.stop
                      >
                        Usage charges are calculated in mega and tiny units
                        based on the
                        <a
                          href="https://docs.google.com/spreadsheets/d/1DM9KBChc3J0LY-0n6MC1X3jc7WtLmknE/edit?gid=1353496847#gid=1353496847"
                          target="_blank"
                          class="text-blue-400 underline hover:text-blue-600"
                        >
                          per-message cost
                        </a>
                        of the destination country.
                        <div
                          class="absolute -top-2 left-4 w-0 h-0 border-l-8 border-r-8 border-b-8 border-transparent border-b-gray-800"
                        ></div>
                      </div>
                    </dt>
                    <dd
                      class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                    >
                      {{ chargeUnits }}
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
import Page from "../components/Common/Page";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Spinner from "vue-simple-spinner";
import {
  subDays,
  format,
  startOfMonth,
  endOfMonth,
  startOfDay,
  endOfDay
} from "date-fns";

export default {
  name: "Billing",
  components: {
    Page,
    DateRangePicker,
    Spinner
  },
  data() {
    return {
      pageTitle: "Billing",
      currentConfig: {
        startDate: "",
        endDate: ""
      },
      ranges: {},
      minDate: new Date(2025, 10, 12), // November 12, 2025 (month is 0-indexed)
      isLoading: false,
      billingReport: {},
      currencyFormat: "",
      showUsageChargeInfo: false
    };
  },
  computed: {
    store() {
      return this.$store.getters.getStore;
    },
    dateDiff() {
      const startDate = this.currentConfig.startDate;
      const endDate = this.currentConfig.endDate;

      if (startDate && endDate) {
        return `${format(startDate, "dd MMM yyyy")} - ${format(
          endDate,
          "dd MMM yyyy"
        )}`;
      }
      return "";
    },
    automatedCharges() {
      if (this.billingReport.automatedCharges !== undefined) {
        return this.formatCurrency(this.billingReport.automatedCharges);
      }
      return this.formatCurrency(0);
    },
    marketingCharges() {
      if (this.billingReport.marketingCharges !== undefined) {
        return this.formatCurrency(this.billingReport.marketingCharges);
      }
      return this.formatCurrency(0);
    },
    teamInboxCharges() {
      if (this.billingReport.teamInboxCharges !== undefined) {
        return this.formatCurrency(this.billingReport.teamInboxCharges);
      }
      return this.formatCurrency(0);
    },
    chargeUnits() {
      if (this.billingReport.chargeUnits !== undefined) {
        return this.billingReport.chargeUnits;
      }
      return 0;
    }
  },
  created() {
    let today = new Date();
    today.setHours(0, 0, 0, 0);

    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    this.ranges = {
      Today: [today, today],
      Yesterday: [yesterday, yesterday],
      "This month": [startOfMonth(today), endOfMonth(today)],
      "Last month": [
        new Date(today.getFullYear(), today.getMonth() - 1, 1),
        new Date(today.getFullYear(), today.getMonth(), 0)
      ]
    };
  },
  mounted() {
    const today = new Date();
    const startDate = subDays(today, 7);
    // Ensure dates are not before min date
    const endDate = today < this.minDate ? new Date(this.minDate) : today;
    const adjustedStartDate =
      startDate < this.minDate ? new Date(this.minDate) : startDate;
    this.currentConfig = {
      startDate: adjustedStartDate,
      endDate: endDate
    };
    this.getBillingReport();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    dateSelected() {
      // Ensure start date is not before min date
      if (
        this.currentConfig.startDate &&
        this.currentConfig.startDate < this.minDate
      ) {
        this.currentConfig.startDate = new Date(this.minDate);
      }
      // Ensure end date is not before min date
      if (
        this.currentConfig.endDate &&
        this.currentConfig.endDate < this.minDate
      ) {
        this.currentConfig.endDate = new Date(this.minDate);
      }
      this.getBillingReport();
    },
    async getBillingReport() {
      this.isLoading = true;
      // TODO: Replace with actual billing API call
      const startDate =
        startOfDay(this.currentConfig.startDate).getTime() / 1000;
      const endDate = endOfDay(this.currentConfig.endDate).getTime() / 1000;
      const response = await this.$store.dispatch("getBillingReport", {
        startDate,
        endDate
      });
      this.billingReport = response;
      this.currencyFormat = response.currencyFormat || "{{amount}}";

      //   // Placeholder data for now
      //   this.billingReport = {
      //     automatedCharges: 0,
      //     marketingCharges: 0
      //   };
      //   this.currencyFormat = "${{amount}}";
      this.isLoading = false;
    },
    formatCurrency(amount) {
      if (this.currencyFormat) {
        return this.currencyFormat.replace("{{amount}}", amount.toFixed(2));
      }
      return `$${amount.toFixed(2)}`;
    },
    handleClickOutside(event) {
      const infoIcon = event.target.closest(
        ".usage-charge-info-icon, .usage-charge-info-tooltip"
      );
      if (!infoIcon && this.showUsageChargeInfo) {
        this.showUsageChargeInfo = false;
      }
    }
  }
};
</script>

<style lang="scss">
.input-date {
  border-radius: 4px;
  font-size: 13px !important;
  font-family: inter;
  font-weight: 400;
}

.daterangepicker .calendars {
  display: flex;
}

.reportrange-text {
  border-radius: 4px;
}
</style>
